export default __webpack_public_path__ + "19af8282f11f30c47e24090088019c7e.otf";